<template>
    <section>
        <div class="container">
            <div class="text-title">Video Tutorials</div>
            <q-card class="q-mb-lg">
                <q-card-section :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md}">
                    <img :src="form.productLine.logo" class="img-tutorial q-mt-md q-mb-sm" :title="form.productLine.name" />
                    <p>Choose your product to browse the latest video lessons provided here.</p>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-4">
                            <q-select outlined dense class="q-mb-md"
                                      bg-color="white"
                                      label="Product Type" stack-label
                                      autocomplete="off"
                                      @input="updateRoute"
                                      v-model="form.productLine" :options="productLines"
                                      option-label="name"
                                      hide-bottom-space />
                        </div>
                    </div>
                </q-card-section>
            </q-card>

            <div class="row justify-center">
                <div class="col">
                    <q-list v-if="tutorialSectionMap.size > 0" class="bg-white">
                        <q-expansion-item v-for="([key, value]) in tutorialSectionMap" :key="key"
                                          :ref="key" :label="key"
                                          dense
                                          style="margin-right: -1px; box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);"
                                          header-style="border-radius: 4px 4px 0 0; margin-top: 10px;"
                                          :header-class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md, 'bg-primary text-white' : true}"
                                          default-opened>
                            <q-separator />
                            <div class="row">
                                <q-list :dense="screenSize.lt.md" class="bg-white col-xs-12 col-md-6">
                                    <q-item v-for="item in firstHalf(value)" :key="item.title"
                                            clickable v-ripple                                            
                                            :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md}"
                                            :active="link === item.title"
                                            @click="link = item.title; form.selectedTutorial = item; showVideo = true;"
                                            active-class="my-menu-link"
                                            style="border: 1px solid rgba(0, 0, 0, 0.12); margin-top: -1px; margin-right: -1px"
                                            :style="screenSize.xs ? 'padding-top: 0.4em!important; padding-bottom: 0.4em!important' : ''">

                                        <q-item-section side>
                                            {{ item.sortOrder }}
                                        </q-item-section>
                                        <q-item-section v-if="item.isNew" avatar side>
                                            <q-badge color="red" label="New" outline />
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label>
                                                {{ item.title }}
                                            </q-item-label>
                                            <q-item-label class="lt-sm" caption>
                                                {{ item.duration }} mins
                                            </q-item-label>
                                        </q-item-section>
                                        <q-item-section class="gt-xs col-auto">
                                            <q-item-label caption>
                                                {{ item.duration }} mins
                                            </q-item-label>
                                        </q-item-section>

                                        <q-item-section class="gt-xs" avatar side>
                                            <q-icon name="mdi-video-outline" size="2em" />
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                                <q-list :dense="screenSize.lt.md" class="bg-white col-xs-12 col-md-6">
                                    <q-item v-for="item in secondHalf(value)" :key="item.title"
                                            clickable v-ripple                                            
                                            :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md}"
                                            :active="link === item.title"
                                            @click="link = item.title; form.selectedTutorial = item; showVideo = true;"
                                            active-class="my-menu-link"
                                            style="border: 1px solid rgba(0, 0, 0, 0.12); margin-top: -1px; margin-right: -1px"
                                            :style="screenSize.xs ? 'padding-top: 0.4em!important; padding-bottom: 0.4em!important' : ''">

                                        <q-item-section side>
                                            {{ item.sortOrder }}
                                        </q-item-section>
                                        <q-item-section v-if="item.isNew" avatar side>
                                            <q-badge color="red" label="New" outline />
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label>
                                                {{ item.title }}
                                            </q-item-label>
                                            <q-item-label class="lt-sm" caption>
                                                {{ item.duration }} mins
                                            </q-item-label>
                                        </q-item-section>
                                        <q-item-section class="gt-xs col-auto">
                                            <q-item-label caption>
                                                {{ item.duration }} mins
                                            </q-item-label>
                                        </q-item-section>

                                        <q-item-section class="gt-xs" avatar side>
                                            <q-icon name="mdi-video-outline" size="2em" />
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                            </div>
                        </q-expansion-item>
                    </q-list>
                </div>
            </div>
        </div>
        <dialog-video-player v-if="form.selectedTutorial" :show.sync="showVideo" :title="form.selectedTutorial.title" :src="form.selectedTutorial.path" />
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    import { tutorials } from '@/plugins/tutorials'
    import dialogVideoPlayer from '@/components/dialogs/DialogVideoPlayer'

    export default {
        name: "tutorials",
        components: {
            dialogVideoPlayer
        },
        data() {
            return {
                showVideo: false,
                link: '',
                productLines: Object.keys(productLines)?.map(key => {
                    return productLines[key]
                })?.filter(pl => pl.name.toLowerCase() !== 'lengthwise'),
                form: {
                    productLine: null,
                    selectedTutorial: null,
                },
            }
        },
        methods: {
            firstHalf(arr) {
                const half = Math.ceil(arr.length / 2)
                return arr.slice(0, half)
            },
            secondHalf(arr) {
                const half = Math.ceil(arr.length / 2)
                return arr.slice(half, arr.length)
            },
            updateProductLine() {
                if (this.$route.query.productLine)
                    this.form.productLine = this.productLines?.find(pl => pl.name.toLowerCase() == this.$route.query.productLine.toLowerCase())
                else if (!this.form.productLine) {
                    this.form.productLine = this.productLines[0]
                }

                this.form.selectedTutorial = null
                this.link = null
                this.updateRoute()
            },
            updateRoute() {
                let queryParams = {}
                if (this.form.productLine)
                    queryParams.productLine = this.form.productLine?.name.toLowerCase()

                this.$router.replace({
                    path: this.$route.path,
                    query: queryParams,
                }).catch(err => { })
            },
        },
        computed: {
            tutorialSectionMap() {
                if (!this.form.productLine) return []
                return this.groupBy(tutorials[this.form.productLine?.name], t => t.section)
            },
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.updateProductLine()
        },
        watch: {
            '$route.query.productLine'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.updateProductLine()
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    .img-tutorial {
        max-width: 100%;
        max-height: 55px;
        width: unset;
    }

    .my-menu-link {
        color: $dark;
        font-weight: 500;
        background: $grey-4;
    }
</style>
